import { StapleTable } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StapleTableStyled = styled(StapleTable)`
  width: max(100%, 65rem);
`;
